import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Modal from './Modal';
import Button from '@material-ui/core/Button';
import { withNamespaces } from 'react-i18next';
import combineStyles from '../../../utils/combineStyles';
import ButtonStyles from '../../../styles/button';
import ConfirmDialogStyles from './ConfirmDialog.styles';

export class MapErrorModal extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired
  };

  render() {
    const { classes, open, onConfirm, t } = this.props;
    return (
      <Modal
        open={open}
        classes={{
          root: classes.modalRoot,
          footer: classes.modalFooter
        }}
        body={
          <Fragment>
            <p className={classes.formTitle}>
              {t('Unable to locate address.')}
            </p>
            <p className={classes.formSubTitle}>
              {t(
                'Please make sure all necessary fields are complete and correct.'
              )}
            </p>
          </Fragment>
        }
        footer={
          <Fragment>
            <Button
              color={'primary'}
              className={classes.textButton}
              onClick={onConfirm}
            >
              {t('OK')}
            </Button>
          </Fragment>
        }
      />
    );
  }
}
const translatedMapErrorModal = withNamespaces()(MapErrorModal);
export default withStyles(combineStyles(ConfirmDialogStyles, ButtonStyles))(
  translatedMapErrorModal
);
